import { Link } from 'react-router-dom';
import PostCard from '@/components/feature/PostCard';
import { getFeaturedPosts, getHotPosts } from '@/utils/content';

export default function FeaturedSection() {
  const featured = getFeaturedPosts();
  const hot = getHotPosts(6);

  return (
    <section id="trending" className="w-full bg-background-100 border-y border-background-200 scroll-mt-20">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="text-xs font-medium text-primary-600 tracking-widest">
              TRENDING / 编辑精选
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              值得一读的高热度话题
            </h2>
          </div>
          <Link
            to="/category/wanghongquan"
            className="inline-flex items-center gap-1 text-sm font-medium text-foreground-800 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部话题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[1.6fr_1fr] gap-6">
          <div className="flex flex-col gap-6">
            {featured.slice(0, 2).map((post) => (
              <PostCard key={post.slug} post={post} variant="feature" />
            ))}
          </div>

          <aside className="rounded-lg border border-background-200 bg-background-50 p-6 lg:sticky lg:top-24 self-start">
            <div className="flex items-center gap-2 mb-2">
              <i className="ri-bar-chart-2-line text-primary-500"></i>
              <h3 className="font-heading text-lg font-bold text-foreground-950">热门阅读榜</h3>
            </div>
            <p className="text-xs text-foreground-500 mb-2">按站内阅读量排序，每小时更新</p>
            <div>
              {hot.map((post, index) => (
                <PostCard key={post.slug} post={post} variant="row" index={index} />
              ))}
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}